import Backbone from "backbone";
import { View } from "../database-reader/base-database-reader";
import { DB_PROVIDERS } from "../database-reader/configs/db-providers";
const module = {};
class SalesforceView extends View {
    setup() {
        this.label = "Salesforce";
        this.model.get("connectionParams").set("type", DB_PROVIDERS.SALESFORCE.id);
        this.model.set("isCDC", false);
    }
}

module.View = SalesforceView;
module.vent = new Backbone.Model();
export default module;
